export default {
  namespaced: true,
  state: {
    fieldParams: {},
    columnNum: 1
  },
  mutations: {
    setFieldParams(state,val){
      state.fieldParams = {...val}
    },
    setColumnNum(state,val){
      state.columnNum = val || 1
    },
    clear(state) {
      state.fieldParams = {}
      state.columnNum = 1
    }
  }
}
